import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["grid", "button", "text", "icon"]
  static values = { viewText: String, hideText: String }

  connect() {
    this.expanded = false
  }

  toggle() {
    this.expanded = !this.expanded

    if (this.hasGridTarget) {
      this.gridTarget.classList.toggle("expanded", this.expanded)
    }

    if (this.hasTextTarget) {
      this.textTarget.textContent = this.expanded ? this.hideTextValue : this.viewTextValue
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-chevron-down", !this.expanded)
      this.iconTarget.classList.toggle("fa-chevron-up", this.expanded)
    }
  }
}
